import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Typography, type SxProps, type Theme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { formatUrl, getStoredReferrer } from "@/hooks/useReferrer";
import { DEFAULT_REDIRECT } from "@/common/config";

interface BackLinkProps {
  url?: string;
  label?: string;
  sx?: SxProps<Theme>;
}

export const BackLink: FC<BackLinkProps> = ({ url, label, sx = {} }) => {
  const { t } = useTranslation();

  // If no URL is provided, try to get it from localStorage, then fall back to default
  const linkUrl = url || getStoredReferrer() || DEFAULT_REDIRECT;

  const displayLabel = label || t("Back to previous page");

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        "&:hover": {
          "& .MuiTypography-root": {
            textDecoration: "underline",
          },
        },
        ...sx,
      }}
    >
      <IconButton
        onClick={() => {
          window.location.href = formatUrl(linkUrl);
        }}
        size="small"
        color="primary"
      >
        <ArrowBackIcon fontSize="small" />
      </IconButton>
      <Typography
        onClick={() => {
          window.location.href = formatUrl(linkUrl);
        }}
        variant="body2"
        color="primary"
        sx={{
          fontSize: "var(--font-size-m)",
          textDecoration: "none",
          cursor: "pointer",
        }}
      >
        {displayLabel}
      </Typography>
    </Box>
  );
};
